class subCollection extends HTMLElement {
    constructor() {
      super();

      const collectionId = document.querySelector(".collection-content").getAttribute('data-section-id');
      const bannerId = this.getAttribute('data-section-id');

      this.sections = {
        main: {
            sectionId: collectionId,
            nodeId: "CollectionAjaxContent"
        },
        banner: {
            sectionId: bannerId,
            nodeId: "collectionBanner"
        },
      };

      this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
      this.collectionBanner = this.querySelector(`#${this.sections.banner.nodeId}`);

      this.init();

      document.addEventListener("sub-collection:init", this.init.bind(this));
    };

    init() {
        const self = this;
        this.subCollectionItems = this.querySelectorAll("[js-sub-collection-item]");
        this.subCollectionSlider = this.querySelector("[js-sub-collection-slider]");
        
        this.subCollectionItems.forEach( item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                if(this.classList.contains('active')) return;
                const collectionHandle = this.dataset.collectionHandle;
                self.initAjaxCollection(collectionHandle, this);
            })
        });

        this.initSubcollectionSlider();
    }

    initSubcollectionSlider() {
        new Swiper(this.subCollectionSlider, {
            freeMode: true,
            breakpoints: {
              0: {
                slidesPerView: "auto",
                spaceBetween: 16
              },
              767: {
                slidesPerView: 3,
                spaceBetween: 20
              },
              1100: {
                slidesPerView: 4,
                spaceBetween: 24
              }
            }
        })
    };

    initAjaxCollection(handle, targetEl) {
        this.changeActiveState(targetEl);
        this.updateHistoryState(handle);
        this.renderCollectionBanner(handle);
        this.renderAjaxCollection(handle);
    };

    changeActiveState(targetEl) {
        this.subCollectionItems.forEach( item => item.classList.remove("active"));
        targetEl.classList.add('active');
    };

    updateHistoryState(handle) {
        var newurl = `${window.location.protocol}//${window.location.host}/collections/${handle}`;
        window.history.replaceState({path: newurl}, '', newurl);
    };

    
    renderCollectionBanner(handle) {
        const self = this;
        const url = `/collections/${handle}?section_id=${this.sections.banner.sectionId}`;

        this.collectionBanner.classList.add("loading");

        fetch(url).then(function(response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            if(document.querySelector(`#shopify-section-${self.sections.banner.sectionId}`)) {
                  document.querySelector(`#shopify-section-${self.sections.banner.sectionId}`).innerHTML = doc.querySelector(`#shopify-section-${self.sections.banner.sectionId}`).innerHTML;
            }
          
            //self.collectionBanner.innerHTML = doc.querySelector(`#${self.sections.banner.nodeId}`)?.innerHTML;
            self.collectionBanner.classList.remove("loading");
            document.dispatchEvent(new CustomEvent('sub-collection:init'));
        });
    };

    renderAjaxCollection(handle) {
     
        const self = this;
        const url = `/collections/${handle}?section_id=${this.sections.main.sectionId}`;

        document.dispatchEvent(new CustomEvent('startLoading:init'));

        fetch(url).then(function(response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            self.ajaxCollectionEl.innerHTML = doc.querySelector(`#${self.sections.main.nodeId}`)?.innerHTML;

            document.dispatchEvent(new CustomEvent('collection:init'));
            document.dispatchEvent(new CustomEvent('quick-add-to-cart:init'));
            document.dispatchEvent(new CustomEvent('updateScroll:init'));

              if(!window.SwymCallbacks){
                  window.SwymCallbacks = [];
              }
              window.SwymCallbacks.push(swymCallbackFn);
          
        });
    }
}
  
customElements.define('sub-collection', subCollection);
  